/* ============================================================
   燈飾照明分區 — per-zone paging + 瀏覽 / 排序方式
   Ported from Code/Aqarahk/lighting.html (Allen, 2026-07-30).

   · Any .lz-grid holding more than data-page-size cards gets a pager; grids at
     or under the limit render none, so a 4-product zone stays a plain row.
   · Sorting reorders the DOM, so every pager registers a reset() and jumps back
     to page 1 — otherwise it would page over a stale card order.
   · Class/attribute toggles and textContent only; no innerHTML UI injection
     beyond the pager scaffold this file owns.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.lzReady === '1') return;
    root.dataset.lzReady = '1';

    var PAGE_SIZE = parseInt(root.dataset.pageSize, 10) || 4;
    var PAGERS = [];

    /* ---------- disown the theme's variant-picker injection ----------
       custom-compare-groups.js walks every [data-product-item] and, for any card
       whose compare JSON carries variants, builds a swatch picker and inserts it
       before `.cc-card-actions` || `.product-card--details` || THE CARD ITSELF.
       Our cards need data-product-item for 比較 to work but have neither of the
       first two hooks, so the picker landed as a direct child of .lz-grid — a
       stray cell rendering bare 銀 / 黑 pills (Allen asked for it gone).
       __ccVarDone is the script's own "already handled" flag, so claiming the
       cards makes it skip them; the sweep clears anything it injected before we
       ran. It only observes [data-body-grid] / related-products / search
       results, none of which contain our grid, so it never re-injects. */
    [].forEach.call(root.querySelectorAll('.lz-card'), function (c) { c.__ccVarDone = true; });
    [].forEach.call(root.querySelectorAll('.lz-grid > .product-card--swatches--horizontal-view'),
      function (n) { n.parentNode.removeChild(n); });

    /* ---------- per-grid pager ---------- */
    [].forEach.call(root.querySelectorAll('.lz-grid'), function (grid) {
      var cards = [].slice.call(grid.querySelectorAll('.lz-card'));
      if (cards.length <= PAGE_SIZE) return;
      var pages = Math.ceil(cards.length / PAGE_SIZE);
      var at = 0;

      var pager = document.createElement('div');
      pager.className = 'lz-pager';
      var dots = '';
      for (var i = 0; i < pages; i++) dots += '<i></i>';
      pager.innerHTML =
        '<span class="lz-dots">' + dots + '</span>' +
        '<button type="button" data-d="-1" aria-label="上一頁">' +
          '<svg viewBox="0 0 24 24"><path d="m14.5 5.5-7 6.5 7 6.5"/></svg></button>' +
        '<span class="lz-at"></span>' +
        '<button type="button" data-d="1" aria-label="下一頁">' +
          '<svg viewBox="0 0 24 24"><path d="m9.5 5.5 7 6.5-7 6.5"/></svg></button>';
      grid.parentNode.insertBefore(pager, grid.nextSibling);

      var prev  = pager.querySelector('[data-d="-1"]');
      var next  = pager.querySelector('[data-d="1"]');
      var label = pager.querySelector('.lz-at');
      var dotEls = [].slice.call(pager.querySelectorAll('.lz-dots i'));

      function render() {
        cards.forEach(function (c, i) {
          c.classList.toggle('is-off', Math.floor(i / PAGE_SIZE) !== at);
        });
        label.textContent = (at + 1) + ' / ' + pages;
        prev.disabled = at === 0;
        next.disabled = at === pages - 1;
        dotEls.forEach(function (d, i) { d.classList.toggle('on', i === at); });
      }

      pager.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-d]');
        if (!b || b.disabled) return;
        /* Pages are not all the same height — a last page holding 2 of 4 cards
           is a row shorter, and on mobile (2-up) every page is two rows tall, so
           the shrink is large. Without this the document reflows under the
           finger and the viewport ends up in the NEXT zone (Allen). Pin the
           pager where it was and the zone stays put. */
        var before = pager.getBoundingClientRect().top;
        at = Math.min(pages - 1, Math.max(0, at + parseInt(b.dataset.d, 10)));
        render();
        var delta = pager.getBoundingClientRect().top - before;
        if (delta) window.scrollBy(0, delta);
      });

      PAGERS.push({ reset: function () {
        cards = [].slice.call(grid.querySelectorAll('.lz-card'));
        at = 0;
        render();
      }});

      render();
    });

    /* ---------- 瀏覽 / 排序方式 ---------- */
    var browseBtn  = root.querySelector('[data-lz-browse]');
    var sortBtn    = root.querySelector('[data-lz-sort]');
    var browseMenu = root.querySelector('[data-lz-browse-menu]');
    var sortMenu   = root.querySelector('[data-lz-sort-menu]');
    if (!browseBtn || !sortBtn) return;

    // built from the zones actually rendered, so it can never fall out of sync
    [].forEach.call(root.querySelectorAll('.lz-zone'), function (z) {
      var h2 = z.querySelector('h2');
      if (!h2) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = h2.textContent;
      b.addEventListener('click', function () {
        closeAll();
        z.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      browseMenu.appendChild(b);
    });

    function closeAll() {
      [browseMenu, sortMenu].forEach(function (m) { m.dataset.open = '0'; });
      [browseBtn, sortBtn].forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    function toggle(btn, menu) {
      var open = menu.dataset.open === '1';
      closeAll();
      if (!open) { menu.dataset.open = '1'; btn.setAttribute('aria-expanded', 'true'); }
    }
    browseBtn.addEventListener('click', function (e) { e.stopPropagation(); toggle(browseBtn, browseMenu); });
    sortBtn.addEventListener('click',   function (e) { e.stopPropagation(); toggle(sortBtn, sortMenu); });
    document.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    [browseMenu, sortMenu].forEach(function (m) {
      m.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    function priceOf(card) {
      var t = (card.querySelector('.lz-pr') || {}).textContent || '';
      return parseFloat(t.replace(/[^\d.]/g, '')) || 0;
    }
    function nameOf(card) { return ((card.querySelector('.lz-nm') || {}).textContent || '').trim(); }

    var sortLabelBase = sortBtn.firstChild.nodeValue;
    sortMenu.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-sort]');
      if (!b) return;
      var mode = b.dataset.sort;
      [].forEach.call(sortMenu.children, function (x) { x.dataset.on = x === b ? '1' : '0'; });
      sortBtn.firstChild.nodeValue = sortLabelBase.trim() + '：' + b.textContent + ' ';

      [].forEach.call(root.querySelectorAll('.lz-grid'), function (grid) {
        var cards = [].slice.call(grid.querySelectorAll('.lz-card'));
        cards.forEach(function (c, i) { if (c.dataset.i === undefined) c.dataset.i = i; });
        cards.sort(function (a, z) {
          if (mode === 'price-asc')  return priceOf(a) - priceOf(z);
          if (mode === 'price-desc') return priceOf(z) - priceOf(a);
          if (mode === 'name')       return nameOf(a).localeCompare(nameOf(z), 'zh-Hant');
          return a.dataset.i - z.dataset.i;
        });
        cards.forEach(function (c) { grid.appendChild(c); });
      });
      PAGERS.forEach(function (p) { p.reset(); });
      closeAll();
    });
  }

  function boot() { [].forEach.call(document.querySelectorAll('.lz-root'), init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.lz-root');
    if (r) { r.dataset.lzReady = '0'; init(r); }
  });
})();
